import { AfterViewInit, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-smart-invoicing-breadcrumb',
  templateUrl: './smart-invoicing-breadcrumb.component.html',
})
export class SmartInvoicingBreadcrumbComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    document.getElementById('custom-breadcrumb').style.width =
      document.querySelector('.lpx-topbar').clientWidth + 'px';
  }
}
